<div class="content">
  <h3>Captures</h3>
  <app-capture-search-settings
    [disableSearch]="loadingInitialResults"
    (performSearch)="onPerformSearch()"
    (performReset)="onPerformReset()" />
  @if (!loadingInitialResults && hasPerformedSearch && hasAnyResults) {
    <div class="mt-1">
      {{ matchingCapturesCount | number }} {{ matchingCapturesCount === 1 ? 'capture' : 'captures' }}
    </div>
    <div infiniteScroll (scrolled)="onScrolled()" [infiniteScrollDisabled]="loadingMoreResults">
      <app-capture-search-results [captureQueueResults]="captureQueueResults" />
      @if (loadingMoreResults) {
        <div class="more-results-spinner">
          <mat-spinner diameter="20" />
        </div>
      }
    </div>
  }

  @if (!loadingInitialResults && hasPerformedSearch && !hasAnyResults) {
    <div class="mt-2 ms-1">
      No captures found. Try modifying the search.
    </div>
  }
  @if (loadingInitialResults) {
    <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
  }
</div>
